<template>
  <img ref="imageRef" :class="[isImageLoaded ? 'opacity-100' : 'opacity-0']" />
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';

  const emit = defineEmits<{
    onLoaded: [];
  }>();

  const imageRef = ref<HTMLImageElement | null>(null);
  const isImageLoaded = ref(false);

  const handleImageLoad = () => {
    isImageLoaded.value = true;
    emit('onLoaded');
  };

  onMounted(() => {
    if (imageRef.value?.complete) {
      handleImageLoad();
    } else {
      isImageLoaded.value = false;
      const onImageLoad = () => {
        handleImageLoad();
        imageRef.value?.removeEventListener('load', onImageLoad);
      };
      imageRef.value?.addEventListener('load', onImageLoad);
    }
  });
</script>
